import { render, staticRenderFns } from "./LogCall.vue?vue&type=template&id=ecf8ecda"
import script from "./LogCall.vue?vue&type=script&lang=js"
export * from "./LogCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports